<template>
  <div
    class="input-list"
    :class="{ 'isrepeatsave': isrepeatsave }"
  >
    <div
      v-for="(item, i) in list"
      :key="`${item}${i}`"
      :class="{'edit-item': list.length > 1}"
    >
      <div
        class="item border-bottom-1px"
      >
        <a
          v-if="data.fieldtype === 'phone'"
          :href="item.fieldvalue && !item.focusVisible ? 'tel:' + item.fieldvalue : 'javascript:;'"
          class="tel"
        >
          <i class="iconfont iconicon-test45 tel-icon" />
        </a>

        <a
          v-if="data.fieldtype === 'phone' && !item.focusVisible"
          :href="'tel:' + item.fieldvalue"
        >
          {{ item.fieldvalue }}
        </a>
        <template v-else>
          <input
            ref="input"
            v-model="item.fieldvalue"
            type="text"
            :placeholder="`${i + 1}.${item.placeholder || enterPlaceholder}`"
            class="my-input"
            :class="{telClass:data.fieldtype === 'phone'}"
            :readonly="!item.focusVisible && data.fieldtype === 'phone'"
            @input="changeValue($event, item)"
            @blur="handleBlur($event, item,i)"
            @click="handleClick(item)"
          >
        </template>
        <i
          v-if="!item.focusVisible && data.fieldtype === 'phone'"
          class="iconfont iconicon-test211 edit-btn"
          @click="handleEdit(item,i)"
        />
        <i
          v-else-if="item.focusVisible && data.fieldtype === 'phone' && list.length > 1"
          class="iconfont iconicon-test35 del-btn"
          @mousedown="handleMouseDown"
          @click="handleDelete(i)"
        />
        <i
          v-else-if="list.length > 1"
          class="iconfont iconicon-test35 del-btn"
          @click="handleDelete(i)"
        />
      </div>
      <div
        v-if="list.length> 1"
        class="item border-bottom-1px"
      >
        <input
          ref="input-mark"
          v-model="item.fieldMark"
          type="text"
          :placeholder="`${item.placeholder || enterPlaceholder}`"
          class="my-input"
          @input="changeValue($event, item)"
          @blur="handleBlur($event, item,i)"
        >
      </div>
    </div>
    <div
      class="fs-blue add-btn"
      @click="handleAdd"
    >
      {{ $t('message["1561"]') }}
    </div>

    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="filterValues"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { checkRepeat } from '@/services/inqueryServices'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      list: [],
      isrepeatsave: 0,
      isEmailError: false,
      filterValues: []
    }
  },
  computed: {
    inquiryId () {
      return this.$route.params.inquiryId
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    checkrepeatfieldvalue () {
      return this.$route.query.checkrepeatfieldvalue
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  created () {
    this.init()

    this.fillCheckRepeatValue()

    // 校验
    if (this.data.fieldtype === 'email') {
      this.data.rules.custom = this.checkEmail
    }
    if (this.data.fieldtype === 'phone') {
      this.data.rules.custom = this.checkPhone
    }
    this.data.rules.captchaCheck = this.validateRepeat
    this.data.messages.captchaCheck = this.$t('message["134"]')
  },
  destroyed () {
    this.UPDATE_REPEAT_SAVE_ITEMS({})
  },
  methods: {
    ...mapMutations('inquery/detailData', [
      'UPDATE_REPEAT_SAVE_ITEMS'
    ]),
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    init () {
      this.data && this.data.fieldvalue.forEach(item => {
        let obj = {}
        const isHasMark = item.indexOf('#') > -1
        let arr = isHasMark ? item.split('#') : []
        arr = arr.filter(item => item !== '')
        obj.fieldvalue = isHasMark ? arr[0] : item
        obj.fieldMark = isHasMark ? item.substring(item.match(/#{1}/).index + 1) : ''
        if (obj.fieldvalue === '') {
          obj.focusVisible = true
        } else {
          obj.focusVisible = false
        }

        this.list.push(obj)
      })
      if (!this.list.length) {
        this.handleAdd()
      }
      this.filterValues = this.list.filter(item => item.fieldvalue !== '')
    },
    handleAdd () {
      if (this.data.fieldtype === 'phone') {
        if (this.list.length >= 1) {
          this.list.push({
            fieldvalue: '',
            fieldMark: '',
            focusVisible: true
          })
          this.$nextTick(function () {
            this.$refs.input && this.$refs.input[this.list.length - 1] && this.$refs.input[this.list.length - 1].focus()
          })
        } else {
          this.list.push({
            fieldvalue: '',
            focusVisible: true
          })
        }
      } else {
        this.list.push({
          fieldvalue: '',
          fieldMark: '',
          focusVisible: false
        })
      }
    },
    setVal () {
      // let values = this.list.map(item => item.fieldvalue)
      let values = this.list.map(item => {
        let str = item.fieldMark ? '#' + item.fieldMark : ''
        return item.fieldvalue + str
      })
      this.data.fieldvalue = values
      this.$emit('change', this.data.fieldvalue)
      this.filterValues = this.list.filter(item => item.fieldvalue !== '')
      this.validate()
      this.$forceUpdate()
    },
    changeValue (e, item) {
      const { fieldtype = '' } = this.data || {}

      this.list.forEach(item => {
        if (fieldtype === 'email') {
          let fieldvalue = item.fieldvalue
          fieldvalue = fieldvalue.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g, '').toLowerCase()
          item.fieldvalue = fieldvalue
          this.$forceUpdate()
        }
        item.fieldvalue = item.fieldvalue.replace(/\s*/g, '')
      })

      this.setVal()
    },
    handleClick (item) {
      if (this.data.fieldtype === 'phone') {
        if (item.fieldvalue && !item.focusVisible) {
          window.location.href = 'tel:' + item.fieldvalue
        }
      }
    },
    handleBlur (e, item, i) {
      if (this.data.fieldtype === 'phone') {
        item.focusVisible = item.fieldvalue === ''
        // this.$set(this.list, i, item)
      }
    },
    fillCheckRepeatValue () {
      const { fieldkey, fieldtype } = this.data
      if (this.checkrepeatfieldkey && this.checkrepeatfieldvalue) {
        if (fieldkey === this.checkrepeatfieldkey) {
          if (fieldtype === 'phone' || fieldtype === 'email') {
            this.data.fieldvalue = this.checkrepeatfieldvalue && this.checkrepeatfieldvalue.split(/[,，\s]+/)
            this.list = this.data.fieldvalue.map(item => {
              return {
                fieldvalue: item
              }
            })
            this.$emit('change', this.data.fieldvalue)
          }
        }
      }
    },
    handleMouseDown (e) {
      e.preventDefault()
    },
    handleDelete (i) {
      this.list.splice(i, 1)
      this.setVal()
      return false
    },
    handleEdit (item, i) {
      item.focusVisible = true
      this.$nextTick(function () {
        this.$refs.input[i].focus()
      })
      this.$set(this.list, i, item)
    },
    checkEmail () {
      const { fieldtype, fieldvalue } = this.data
      if (fieldtype !== 'email') {
        return true
      }
      if (fieldvalue.length === fieldvalue.filter(value => value === '').length) {
        this.data.messages.custom = this.placeholder
        return true
      }
      let error = true
      for (let item of fieldvalue) {
        // let str = item.indexOf('#') > -1 ? item.split('#')[0] : item
        let arr = item.indexOf('#') > -1 ? item.split('#') : []
        arr = arr.filter(item => item !== '')
        let curvalue = fieldvalue.findIndex(item2 => item2 === item) || 0
        let str = item.indexOf('#') > -1 ? this.list[curvalue].fieldvalue : item
        if (!/^[A-Za-z\d0-9]+([-_.][A-Za-z\d0-9]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,64}$/.test(str)) {
          // 邮箱不是有效的邮箱格式
          this.data.messages.custom = this.$t('message["1508"]')
          error = false
        }
      }
      this.isEmailError = !error
      return error
    },
    checkPhone () {
      const { fieldtype, fieldvalue, fieldconfig = {} } = this.data

      if (fieldtype !== 'phone' || !fieldconfig.check) {
        return true
      }
      if (fieldvalue.length === fieldvalue.filter(value => value === '').length) {
        this.data.messages.custom = this.placeholder
        return true
      }
      let error = true
      for (let item of fieldvalue) {
        let arr = item.indexOf('#') > -1 ? item.split('#') : []
        arr = arr.filter(item => item !== '')
        let str = item.indexOf('#') > -1 ? arr[0] : item
        if (!/^[1][0,3,4,5,6,7,8,9][0-9]{9}$/.test(str)) {
          // 手机格式不正确
          this.data.messages.custom = this.$t('message["1111"]')
          error = false
        }
      }
      this.isEmailError = !error
      return error
    },
    validateRepeat () {
      let { fieldkey = '', fieldvalue, fieldrepeat } = this.data || {}
      if (this.$toType(fieldvalue) === 'array') {
        fieldvalue = fieldvalue.filter(item => item !== '')
        fieldvalue = fieldvalue.map(item => {
          return item.indexOf('#') > -1 ? item.split('#')[0] : item
        })
      }
      return (resolve) => {
        if (!fieldrepeat || !fieldvalue || !fieldvalue.length || this.isEmailError) {
          return resolve(true)
        }
        checkRepeat().params({
          inquiryid: this.inquiryId,
          fieldkey,
          fieldvalue
        })
          .fetch()
          .then(res => {
            const { payload = {} } = res.data
            const { isrepeat = 0, isrepeatsave = 0 } = payload
            this.isrepeatsave = isrepeat && isrepeatsave

            // 存放查重验证，重复可保存字段
            this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, this.repeatSaveItems, {
              [fieldkey]: this.isrepeatsave
            }))

            resolve(isrepeat === 0)
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-list {
  width: 100%;
}
.item {
  display: flex;
  align-items: center;
  .tel-icon {
    padding-right: 6px;
    color: #5077aa;
  }
  .telClass {
    color: #5077aa;
  }
  .my-input,
  .cube-input {
    width: 200px;
  }
  .my-input {
    outline: none;
    &::-webkit-input-placeholder {
      color: #d6d6d6;
    }
  }
}
.del-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 10px;
  margin-right: -10px;
  font-size: 16px;
  color: $danger-color;
}
.edit-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 10px;
  margin-right: -10px;
  font-size: 16px;
  color: #5077aa;
}
.add-btn {
  display: inline-block;
  height: 48px;
  line-height: 48px;
}
.isrepeatsave ::v-deep {
  .cube-validator-msg-def {
    color: #f6a953;
  }
}
</style>
